export function getErrorMessage(error: unknown): string {
  if (error instanceof Error) return error.message;
  return String(error ?? '');
}

export function isHttpStatusError(error: unknown, status: number): boolean {
  const message = getErrorMessage(error);
  return message.includes(`HTTP ${status}`) || message.includes(`(${status})`);
}

export function isUnauthorizedHttpError(error: unknown): boolean {
  const message = getErrorMessage(error);
  return isHttpStatusError(error, 401)
    || message.includes('유효하지 않은 JWT 토큰입니다.')
    || message.includes('세션이 만료되었거나 폐기되었습니다.')
    || message.includes('유효하지 않은 사용자 세션입니다.')
    || message.includes('토큰에 세션 식별자(jti)가 없습니다.')
    || message.includes('Authorization Bearer 토큰이 필요합니다.');
}

export function isForbiddenHttpError(error: unknown): boolean {
  return isHttpStatusError(error, 403);
}

export function isNotFoundHttpError(error: unknown): boolean {
  return isHttpStatusError(error, 404);
}

export function isWorkspaceItemAccessDeniedError(error: unknown): boolean {
  return isForbiddenHttpError(error);
}

export function isWorkspaceItemUnavailableError(error: unknown): boolean {
  return isForbiddenHttpError(error) || isNotFoundHttpError(error);
}
